/*
  hc-init.js — 中身（#hc-main）の中の部品の初期化をまとめたもの。layout/theme.liquid で全ページ読み込む。

  なぜ javascript タグ ではなくここか：
  Shopify の javascript タグ は「最初に開いたページにある部品」の分しか有効にならない。
  スマホのタブ（sections/header.liquid の swapTo）はページを読み直さず中身だけ差し替えるので、
  差し替え先にしか無い部品（TOP のブランドのスライド、横スクロールの「次へ」など）が動かなくなる。
  ここに置いて、読み込み時と差し替えのたびに window.hcRunInit() を呼ぶ。各処理は data-bound で二重実行を防ぐ。
*/
(function () {
  var inits = [];

  /* 横スクロールの「次へ」ボタン（TOP。PCのみ動作） */
  inits.push(function () {
    document.querySelectorAll('.hs-wrap').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var btn = wrap.querySelector('.hs-next');
      var hs = wrap.querySelector('.hs');
      if (!btn || !hs) return;
      btn.addEventListener('click', function () { hs.scrollBy({ left: 188 * 3, behavior: 'smooth' }); });
    });
  });

  /* ブランドのスライド（snippets/brand-marquee.liquid） */
  inits.push(function () {
    document.querySelectorAll('[data-brand-marquee]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var track = root.querySelector('.bm-track');
      var set = root.querySelector('.bm-set');
      if (!track || !set) return;
      // 毎回同じ並びにならないよう順番をシャッフル
      var items = Array.prototype.slice.call(set.children);
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = items[i]; items[i] = items[j]; items[j] = t;
      }
      items.forEach(function (el) { set.appendChild(el); });
      // 2周目（切れ目なくつなぐための複製）。読み上げ・タブ移動の対象からは外す
      var clone = set.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      track.appendChild(clone);
      root.classList.add('is-ready');
    });
  });

  /* ブランド一覧の絞り込み（snippets/brand-directory.liquid） */
  inits.push(function () {
    function norm(s) {
      return (s || '')
        .normalize('NFKC')
        .toLowerCase()
        .replace(/[ぁ-ゖ]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) + 0x60); })
        .replace(/[\s・･\-]/g, '');
    }
    document.querySelectorAll('.bd').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var input = root.querySelector('.bd-filter');
      var empty = root.querySelector('.bd-empty');
      var index = root.querySelector('.bd-index');
      if (!input) return;
      input.addEventListener('input', function () {
        var q = norm(input.value);
        var total = 0;
        root.querySelectorAll('[data-group]').forEach(function (sec) {
          var shown = 0;
          sec.querySelectorAll('.bd-card').forEach(function (a) {
            var hit = !q || norm(a.dataset.q).indexOf(q) !== -1;
            a.style.display = hit ? '' : 'none';
            if (hit) shown++;
          });
          sec.style.display = shown ? '' : 'none';
          total += shown;
        });
        if (index) index.style.display = q ? 'none' : '';
        if (empty) empty.hidden = total !== 0;
      });
    });
  });

  window.hcRunInit = function () {
    inits.forEach(function (fn) { try { fn(); } catch (e) { console.error(e); } });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.hcRunInit);
  else window.hcRunInit();

  /* セットのカート追加（snippets/set-pair-card.liquid）。document に1回だけ付ける委任なので差し替え後もそのまま効く */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.spc-add');
    if (!btn) return;
    var items;
    if (btn.dataset.bundleVariant) {
      /* バンドル商品（セット割引あり）は1点だけ入れる。中身は注文時に構成品へ展開される */
      items = [{ id: Number(btn.dataset.bundleVariant), quantity: 1 }];
    } else if (btn.dataset.shVariant) {
      items = [
        { id: Number(btn.dataset.shVariant), quantity: 1 },
        { id: Number(btn.dataset.trVariant), quantity: 1 }
      ];
    } else {
      return;
    }
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = '追加中...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { btn.textContent = orig; btn.disabled = false; });
  });
})();
